import { render, staticRenderFns } from "./bigCustClueReportNoStrain.vue?vue&type=template&id=b612a3be&scoped=true&"
import script from "./bigCustClueReportNoStrain.vue?vue&type=script&lang=js&"
export * from "./bigCustClueReportNoStrain.vue?vue&type=script&lang=js&"
import style0 from "./bigCustClueReportNoStrain.vue?vue&type=style&index=0&id=b612a3be&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b612a3be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b612a3be')) {
      api.createRecord('b612a3be', component.options)
    } else {
      api.reload('b612a3be', component.options)
    }
    module.hot.accept("./bigCustClueReportNoStrain.vue?vue&type=template&id=b612a3be&scoped=true&", function () {
      api.rerender('b612a3be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/report/bigCustClueReportNoStrain/bigCustClueReportNoStrain.vue"
export default component.exports